/**
 * Application Routes Configuration
 * Single source of truth for all route paths
 */

export const ROUTES = {
  // Auth routes
  LOGIN: '/login',
  AUTH_CALLBACK: '/auth/callback',

  // Main application routes
  ROOT: '/',
  DASHBOARD: '/dashboard',

  // Booking routes
  MY_BOOKINGS: '/bookings/my-bookings',
  MY_BOOKINGS_DETAIL: '/bookings/my-bookings/:bookingId',
  MY_BOOKINGS_FILTER: '/bookings/my-bookings/:filter',
  MY_BOOKINGS_FILTER_DETAIL: '/bookings/my-bookings/:filter/:bookingId',
  BOOK_ROOM: '/bookings/rooms', // Room browsing page (wizard opens via ?wizard=true&roomId=...)
  BOOK_EQUIPMENT: '/bookings/equipment', // Equipment booking wizard page
  ROOMS_WIZARD: '/bookings/rooms?wizard=true', // Direct link to open room booking wizard
  EQUIPMENT_WIZARD: '/bookings/equipment', // Equipment wizard (same as BOOK_EQUIPMENT)

  // Calendar routes (with nested structure + booking modals)
  CALENDAR: '/calendar',
  CALENDAR_ROOMS: '/calendar/rooms',
  CALENDAR_ROOMS_BOOKING: '/calendar/rooms/booking',
  CALENDAR_EQUIPMENT: '/calendar/equipment',
  CALENDAR_EQUIPMENT_BOOKING: '/calendar/equipment/booking',

  // Admin routes (with nested structure)
  ADMIN: '/admin',
  ADMIN_APPROVALS: '/admin/approvals',
  ADMIN_APPROVALS_DETAIL: '/admin/approvals/:bookingId',
  ADMIN_USERS: '/admin/users',
  ADMIN_ROOMS: '/admin/rooms',
  ADMIN_EQUIPMENT: '/admin/equipment',
  ADMIN_STAFF: '/admin/staff',
  ADMIN_EXPERTISES: '/admin/expertises',
  ADMIN_ACTIVITY: '/admin/activity',
  ADMIN_APPEARANCE: '/admin/appearance',
  ADMIN_PLUGINS: '/admin/plugins',
  ADMIN_STATISTICS: '/admin/statistics',
  ADMIN_RECURRING: '/admin/recurring',

  // Legacy routes (kept for backward compatibility)
  USERS: '/users',
  RESOURCES: '/resources',

  // Files route (always available, no plugin gate)
  FILES: '/files',

  // Public routes (no auth)
  BOARD: '/board',
  SHARED_FILE: '/shared/:key',

  // Settings routes
  SETTINGS: '/settings',
  SETTINGS_PROFILE: '/settings/profile',
  SETTINGS_ORGANIZATION: '/settings/organization',
  SETTINGS_PLUGINS: '/settings/plugins',
  SETTINGS_THEME: '/settings/theme',
  SETTINGS_NOTIFICATIONS: '/settings/notifications'
} as const;

/**
 * Default routes for different authentication states
 */
export const DEFAULT_AUTHENTICATED_ROUTE = ROUTES.MY_BOOKINGS;
export const DEFAULT_UNAUTHENTICATED_ROUTE = ROUTES.LOGIN;

/**
 * Routes that don't require authentication
 */
export const PUBLIC_ROUTES = [
  ROUTES.LOGIN
] as const;

/**
 * Routes that require admin privileges
 */
export const ADMIN_ROUTES = [
  ROUTES.ADMIN,
  ROUTES.ADMIN_APPROVALS,
  ROUTES.ADMIN_USERS,
  ROUTES.ADMIN_ROOMS,
  ROUTES.ADMIN_EQUIPMENT,
  ROUTES.ADMIN_STAFF,
  ROUTES.ADMIN_EXPERTISES,
  ROUTES.ADMIN_ACTIVITY,
  ROUTES.ADMIN_APPEARANCE,
  ROUTES.ADMIN_PLUGINS,
  ROUTES.ADMIN_STATISTICS,
  ROUTES.ADMIN_RECURRING,
  ROUTES.USERS,
  ROUTES.SETTINGS_ORGANIZATION
] as const;
